module.exports = __webpack_public_path__ + "static/polar-env2-d2cd97ffeba01d8c79b7aff3c48d6373.jpg";